import React from 'react';
import { Box, Typography, Button, List, ListItem, ListItemIcon } from '@mui/material';
import { PlayCircleOutline, DescriptionOutlined, QuestionAnswerOutlined } from '@mui/icons-material';
import box91 from '../assets/images/box-9-1.png';
import { useNavigate } from 'react-router-dom';
import { AuthData } from '../types';

interface Props {
  loginData: null | AuthData;
}


const HelpPortalBanner = ({loginData}: Props) => {

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: { xs: '400px', md: '500px' },
        backgroundImage: `url(${box91})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        p: { xs: 2, md: 4 },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          maxWidth: {xs: '100%', md: '50%'},

          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          borderRadius: 2,
          p: { xs: 3, md: 4 },
          color: 'black',
        }}
      >
        <Typography 
          variant="overline" 
          component="div" 
          sx={{
            color: 'orange',
            fontWeight: 'bold',
            fontSize: '0.9rem',
            mb: 1,
          }}
        >
          DOCUMENTACIÓN
        </Typography>
        
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{
            fontWeight: 'bold',
            fontSize: { xs: '1.8rem', md: '2.2rem' },
          }}
        >
          Bienvenido al Portal de Ayuda S10 Hecho para clientes
        </Typography>
        
        <List sx={{ mb: 3 }}>
          <ListItem sx={{ px: 0 }}>
            <ListItemIcon sx={{ minWidth: '36px', color: 'black' }}>
              <DescriptionOutlined />
            </ListItemIcon>
            <Typography>Manuales de Uso actualizados</Typography>
          </ListItem>
          
          <ListItem sx={{ px: 0 }}>
            <ListItemIcon sx={{ minWidth: '36px', color: 'black' }}>
              <PlayCircleOutline />
            </ListItemIcon>
            <Typography>Videos Tutoriales</Typography>
          </ListItem>
          
          <ListItem sx={{ px: 0 }}>
            <ListItemIcon sx={{ minWidth: '36px', color: 'black' }}>
              <QuestionAnswerOutlined />
            </ListItemIcon>
            <Typography>Listado de Preguntas Frecuentes</Typography>
          </ListItem>
        </List>
        
        {!loginData?.UserId && <Button 
          variant="contained" 
          color="primary" 
          size="large"
          sx={{
            px: 4,
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 'bold',
            textTransform: 'uppercase',
          }}
          onClick={() => navigate('/login')}
        >
          Accede al Portal
        </Button>}
      </Box>
    </Box>
  );
};

export default HelpPortalBanner;